<template>
    <Popup
      @close="closeTaskDialog"
      :fullPage="true"
      :contentScrim="false"
      class="task-setting-dlg-wrap"
    >
      <TaskDialog
        @closeMe="closeTaskDialog()"
      />
    </Popup>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import TaskDialog from '@/components/widgets/TaskDialog';
import eventBus from '@/eventBus';
import { generateAppUrl, openDesktopApp } from '@/utils';

// Reactive data
const loadedFromDirectNavigation = ref(false);
const showInAppTriggered = ref(false);

// Store and router
const store = useStore();
const router = useRouter();

// Computed properties
const taskUnderEdit = computed(() => store.state.project.taskUnderEdit);
const appOpenState = computed(() => store.state.user.appOpenState);

// Actions and mutations
const actionUnsubTask = (taskId) => store.dispatch('project/actionUnsubTask', taskId);
const actionGetTaskAndOpen = (payload) => store.dispatch('project/actionGetTaskAndOpen', payload);
const mutationCloseTaskPopup = () => store.commit('project/mutationCloseTaskPopup');

// Methods
const closeTaskDialog = () => {
  const openedFromParentId = store.state.project.openedFromParentId;
  if (openedFromParentId) {
    actionGetTaskAndOpen({ id: openedFromParentId });
    return;
  }
  if (!loadedFromDirectNavigation.value) {
    router.go(-1);
  } else {
    const task = taskUnderEdit.value;
    if (!task?.project?.slug) {
      router.push('/project/last/Last');
      return;
    }
    router.push({
      name: 'project',
      params: {
        projectSlug: task.project.slug,
        slugNameProject: task.project.nameSlug || task.project.slug,
      },
    });
  }
};

// Lifecycle hooks
onMounted(async () => {
  if (!taskUnderEdit.value) {
    // then it loaded directly from non SPA navigation
    loadedFromDirectNavigation.value = true;
  }
  eventBus.$emit('open-task-dialog', true);
});

onBeforeUnmount(async () => {
  if (taskUnderEdit.value?.id) {
    actionUnsubTask(taskUnderEdit.value.id);
  }
  mutationCloseTaskPopup();
  loadedFromDirectNavigation.value = false;
  eventBus.$emit('open-task-dialog', false);
});

// Watchers
watch(appOpenState, async (newValue) => {
  if (newValue
    && loadedFromDirectNavigation.value
    && !showInAppTriggered.value
    && !window.APP_TRON) {
    const url = generateAppUrl('open', { path: window.location.pathname });
    await openDesktopApp(url);
    showInAppTriggered.value = true;
  }
});
</script>
